import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsnavs',
	templateUrl:'./BSNavsPage.html',
	styles: [],
	styleUrls:['./BSNavsPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSNavsPage
{
	mdContent_134 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.navs.BSNavs;
\`\`\``;
	mdContent_135 = `\`\`\`java
new BSNavs<>()
\`\`\``;
	mdContent_136 = `\`\`\`java
var navs = new BSNavs<>();
navs.setPills(false);

var tab1 = new BSNavItem<>();
tab1.setText("Home");
tab1.setActive(true);

var tab2 = new BSNavItem<>();
tab2.setText("Profile");

navs.addTab(tab1);
navs.addTab(tab2);
\`\`\``;
	mdContent_137 = `\`\`\`java
var navs = new BSNavs<>();
navs.setPills(true);
navs.setFill(true);
\`\`\``;
}
